export default class TimeEntryForm {
    id: number;    
    akaName?: string;
    tsdiNumber?: number;
    name?: string;
    isContractor?: boolean;
}



// WEBPACK FOOTER //
// ./src/models/AP/TimeEntryForm.ts